export const CLEAR_SELLERS_DATA = "CLEAR_SELLERS_DATA";
export const SET_ALL_SELLERS = "SET_ALL_SELLERS";
export const SET_SELECTED_SELLER = "SET_SELECTED_SELLER";
export const GET_CURRENT_USER_SELLERS_REQUEST_ERROR = "SET_CURRENT_USER_SELLERS_REQUEST_ERROR";
export const SET_CURRENT_SELLER_STATISTIC = "SET_CURRENT_SELLER_STATISTIC";
export const SET_CURRENT_SELLER_INFO = "SET_CURRENT_SELLER_INFO";
export const SET_CURRENT_SELLER_IS_LOADING = "SET_CURRENT_SELLER_IS_LOADING";
export const SET_CURRENT_SELLER_REQUEST_ERROR = "SET_CURRENT_SELLER_REQUEST_ERROR";
export const SET_SELLER_REVIEWS_IFRAME_URL = "SET_SELLER_REVIEWS_IFRAME_URL";
export const SET_SELLER_AI_CLIENT_STATUS = "SET_SELLER_AI_CLIENT_STATUS";